<template>
  <div
    class="cloudprint-details"
    >
    <div class="cloudprint-details-header">
      <slot name="header"/>
    </div>
    <div class="cloudprint-details-body">
      <slot name="body"/>
    </div>
  </div>
</template>
<script>
  export default {
    props: [],
    data: () => ({
    }),
  }
</script>
<style>
  .cloudprint-details {
    position: relative;
    overflow: hidden;
    height: 100%;
  }
  .cloudprint-details-header {
    display: flex;
    height: 36px;
    background-color: grey;
    align-items: center;
  }
  .cloudprint-details-body {
    position: relative;
    width: 100%;
    height: calc(100% - 36px);
    padding: 3px;
    overflow: auto;
  }
</style>
